import { forwardRef, Icon, IconProps } from '@chakra-ui/react';

const Ship = forwardRef<IconProps, 'svg'>((props, ref) => (
  <Icon ref={ref} viewBox="0 0 16 16" {...props}>
    <path
      clipRule="evenodd"
      d="m7.303 10.16-.257 3.173.835-.143c.084-.014 2.06-.362 3.434-1.64.646-.6.695-1.173.752-1.835.04-.466.088-1.04.337-1.903 2.552-2.458 2.255-5.82 2.25-5.878l-.055-.533-.534-.055h-.004c-.141-.011-3.447-.27-5.874 2.25a8.862 8.862 0 0 1-1.9.338c-.664.055-1.237.104-1.838.75C3.172 6.06 2.823 8.035 2.81 8.12l-.142.834 3.174-.256A1.922 1.922 0 0 0 7.52 7.35c1.29-4.088 4.51-4.65 5.835-4.704-.047 1.325-.599 4.536-4.705 5.833a1.923 1.923 0 0 0-1.348 1.68Zm-.87-4.918c.173-.015.367-.032.588-.06a9.521 9.521 0 0 0-.756 1.77.612.612 0 0 1-.53.433l-1.4.113c.195-.574.533-1.331 1.079-1.918.246-.265.382-.284.983-.335l.035-.003Zm2.614 4.492a9.53 9.53 0 0 0 1.771-.754c-.03.234-.048.44-.063.622-.051.601-.072.738-.337.984-.586.545-1.344.884-1.916 1.078l.113-1.398a.613.613 0 0 1 .432-.532Z"
      fill="currentColor"
      fillRule="evenodd"
    />
    <path
      d="m1.445 13.693-.778 1.64 1.64-.779c.308-.146 3.026-1.447 3.806-2.228.23-.231.503-.714.554-1.229l-1.288-.127a.942.942 0 0 1-.18.442c-.258.257-.943.67-1.688 1.077.406-.745.82-1.43 1.077-1.687a.94.94 0 0 1 .44-.181l-.124-1.288c-.515.05-.999.322-1.23.554-.781.78-2.083 3.498-2.229 3.806Z"
      fill="currentColor"
    />
  </Icon>
));

export default Ship;
